import { render, staticRenderFns } from "./job-category.vue?vue&type=template&id=cc563d4a&scoped=true&"
import script from "./job-category.vue?vue&type=script&lang=js&"
export * from "./job-category.vue?vue&type=script&lang=js&"
import style0 from "./job-category.vue?vue&type=style&index=0&id=cc563d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc563d4a",
  null
  
)

export default component.exports